import { initialState } from './reducer';

export interface IAccessLogStore {}

export function getInitialAccessLogStore(): IAccessLogStore {
  return { ...initialState };
}
